import React from 'react';
import get from 'lodash/get';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { usePortfolioGroup } from './usePortfolioGroup';
import { ModelGroupDTO } from '../../ManageExcessCashModal.meta';

interface Props {
  formKey?: string;
  options: ModelGroupDTO[];
}

export const PortfolioGroup = ({
  formKey = 'ExcessCashFlowStrategy.data.modelPortfolios.id',
  options: portfolioGroup,
}: Props) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const { modelPortfolios: options } = usePortfolioGroup({ portfolioGroup });

  const error = get(errors, formKey) as FieldError | undefined;

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            isPortal
            value={options
              .map(({ options }) => options)
              .flat()
              .find(opt => opt.value === value)}
            options={options}
            onChange={opt => {
              onChange(opt?.value);
              const selectedModel = portfolioGroup
                .map(item => item.modelPortfolios)
                .flat()
                .filter(model => model.id === opt?.value)[0];

              setValue('ExcessCashFlowStrategy.data.modelPortfolios', { ...selectedModel });
            }}
            formVariant={error && 'error'}
            helperText={error?.message}
            aria-label="Select the Model Portfolio"
          />
        );
      }}
    />
  );
};
